/**
 * Environment Configuration - Development
 */
export const environment = {
  production: false,
  apiUrl: 'http://localhost:3000/api',
  storageUrl: 'http://localhost:3000/storage',
  socketUrl: 'http://localhost:3000/',
  diditSocketUrl: 'https://api-staging.comex360.trade',
  appName: 'Comex360'
};
